import React from 'react';

const SectionWrapper = ({ title, children, additionalClass = '' }) => (
    <div className={`container section-gap-large ${additionalClass}`}>
        <div className="section-title section-center" data-sal-delay="150" data-sal="slide-up" data-sal-duration="800">
            <h3 className="title">{title}</h3>
            {/* <div className="separator-line">
                <hr className="separator-horizontal" />
                <hr className="separator-vertical" />
            </div> */}
        </div>
        <div className="row g-5 mt-4">
            {children}
        </div>
    </div>
);

export default SectionWrapper; 